function onResize() {
    let innerWidth = window.innerWidth;

    //menu
    let menuHelmets = document.querySelector('#HeaderMenu-helmets > span').getBoundingClientRect();
    let menuKids    = document.querySelector('#HeaderMenu-kids > span').getBoundingClientRect();
    let menuGoggles = document.querySelector('#HeaderMenu-goggles > span').getBoundingClientRect();
    let menuSupport = document.querySelector('#HeaderMenu-support > span').getBoundingClientRect();

    let helmetsSubmenu = document.querySelector('#MegaMenu-Content-1 .mega-menu__list');
    let kidsSubmenu    = document.querySelector('#MegaMenu-Content-2 .mega-menu__list');
    let gogglesSubmenu = document.querySelector('#MegaMenu-Content-3 .mega-menu__list');
    let supportSubmenu = document.querySelector('#MegaMenu-Content-5 .mega-menu__list');

    helmetsSubmenu.style.left = menuHelmets.left + "px";
    kidsSubmenu.style.left    = menuKids.left + "px";
    gogglesSubmenu.style.left = menuGoggles.left + "px";
    supportSubmenu.style.left = menuSupport.left + "px";

    //prodotto
    /*let productDetail = document.querySelector('.ecom-product-form--single > section > .core__row--columns > .core__column--last');
    if (productDetail) {
        productDetail = productDetail.getBoundingClientRect();

        let btnRight = document.querySelector('#ecom-prodotti-origine .ec_splide__arrow--next');
        btnRight.style.right = (innerWidth > 1024 ? (innerWidth - productDetail.left) : 8) + "px";
    }*/
}

function onThumbChange() {
    clearTimeout(variantSyncTimer);

    variantSyncTimer = setTimeout(() => {
        const variantsScript = document.querySelector(
            "script[data-variants]"
        );

        const activeImg = document.querySelector(
            ".ecom-product-single__media--featured " +
            ".ec_splide__list .ec_splide__slide.is-active"
        );

        if (!variantsScript || !activeImg) return;

        const variants = JSON.parse(variantsScript.textContent);

        const slides = Array.from(activeImg.parentElement.children)
            .filter(element =>
                element.classList.contains("ec_splide__slide") &&
                !element.classList.contains("is-clone")
            );

        let referenceSlide = activeImg;
        let slideIndex = slides.indexOf(activeImg);

        while (
            !referenceSlide.getAttribute("data-variant_id")?.trim() &&
            slideIndex > 0
        ) {
            slideIndex--;
            referenceSlide = slides[slideIndex];
        }

        const imageVariantIds = (
            referenceSlide.getAttribute("data-variant_id") || ""
        )
            .split(",")
            .map(id => id.trim())
            .filter(Boolean);

        if (!imageVariantIds.length) return;

        const matchingVariant = variants.find(variant => {
            const ids = variant.featured_image?.variant_ids || [];

            return ids.some(id =>
                imageVariantIds.includes(String(id))
            );
        });

        if (!matchingVariant) return;

        const colorOptions = document.querySelectorAll(
            ".ecom-product-single__picker-images-list [data-value]"
        );

        const option = Array.from(colorOptions).find(
            element =>
                element.dataset.value === matchingVariant.option1
        );

        if (option && !option.classList.contains("ecom-image-active")) {
            const gallery = activeImg.closest(
                ".ecom-product-single__media--featured"
            );

            const slider = gallery?.ec_splide;

            if (!slider || typeof slider.go !== "function") {
                // Non cambiamo colore se non possiamo controllare
                // lo spostamento della galleria.
                return;
            }

            const originalGo = slider.go;
            const hadOwnGo = Object.prototype.hasOwnProperty.call(
                slider,
                "go"
            );

            try {
                // Blocca lo spostamento richiesto durante il clic
                // automatico, senza modificare la slide attuale.
                slider.go = function () {
                    return this;
                };

                option.click();
            } finally {
                // Ripristina subito il comando originale:
                // frecce e clic manuali continuano a funzionare.
                if (hadOwnGo) {
                    slider.go = originalGo;
                } else {
                    delete slider.go;
                }
            }
        }
    }, 500);
}

let lang = document.querySelector("html").getAttribute("lang");

onResize();
window.onresize = onResize;

//rimozione click su voci del menu
/*let vociMenu = ["HeaderMenu-helmets-classic", "HeaderMenu-helmets-urban", "HeaderMenu-helmets-bluetooth", "HeaderMenu-helmets-kids"];
vociMenu.forEach((voce) => {
    document.getElementById(voce).addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
    });
});*/

let variantSyncTimer;
const prodottiPage = document.getElementById("ecom-prodotti-origine");

if (prodottiPage) {
    const arrows = document.querySelectorAll(
        ".ecom-product-single__media--slider .ec_splide__arrows " +
        ".ecom-swiper-button-next, " +
        ".ecom-product-single__media--slider .ec_splide__arrows " +
        ".ecom-swiper-button-prev"
    );

    arrows.forEach(arrow => {
        arrow.addEventListener("click", onThumbChange);
    });
}

let itCertPage = document.querySelector("#MainContent.certificazioni");
if (itCertPage) {
    let links = document.querySelectorAll(".certificazioni .menu-certification a");

    links.forEach((el, i) => {
        if (i > 2) return;
        el.textContent = i == 0 ? 'Certificazioni Caschi da moto' : 'Certificazioni Lenti';
    });
}

if (lang == "it") {
    let titleCart = document.querySelector("#shopify-section-template--26405310529868__cart-items .title--primary");
    if (titleCart) titleCart.innerHTML = 'Carrello';

    let checkoutBtn = document.querySelector("#checkout.cart__checkout-button");
    if (checkoutBtn) checkoutBtn.innerHTML = 'Checkout';
}
